import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { GiftMessage } from '../gift-message';
import { t } from '../../../theme/locales';
const StepComplimentaryMessage = ({ state , setState  })=>{
    useEffect(()=>{
        if (state.complimentaryMessage) return;
        fetch('/cart.js').then((r)=>r.json()).then((cart)=>{
            if (cart === null || cart === void 0 ? void 0 : cart.note) setState({
                complimentaryMessage: cart.note
            });
        }).catch((err)=>console.warn('Failed to load cart note', err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _state_complimentaryMessage;
    return h('div', {
        className: 'gift-wrapping__step'
    }, [
        h(GiftMessage, {
            title: t('gift_wrapping.steps.complimentary_message.label'),
            description: t('gift_wrapping.steps.complimentary_message.description'),
            placeholder: t('gift_wrapping.steps.complimentary_message.placeholder'),
            value: (_state_complimentaryMessage = state.complimentaryMessage) !== null && _state_complimentaryMessage !== void 0 ? _state_complimentaryMessage : '',
            fieldName: 'complimentary_message',
            onChange: (v)=>setState({
                    complimentaryMessage: v
                }),
            className: 'gift-wrapping__message--complimentary'
        })
    ]);
};
export default StepComplimentaryMessage;
